import _defineProperty from "@babel/runtime/helpers/defineProperty";
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
import { css } from '@emotion/react';
import { BodiedSyncBlockSharedCssClassName, SyncBlockSharedCssClassName, SyncBlockLabelSharedCssClassName, SyncBlockStateCssClassName } from '@atlaskit/editor-common/sync-block';
import { akEditorGutterPadding } from '@atlaskit/editor-shared-styles';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var syncBlockStyles = css(_defineProperty({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.ProseMirror': _defineProperty({}, ".".concat(SyncBlockSharedCssClassName.prefix, ", .").concat(BodiedSyncBlockSharedCssClassName.prefix), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    position: 'relative',
    cursor: 'pointer',
    borderRadius: "var(--ds-radius-small, 3px)",
    marginTop: "var(--ds-space-150, 12px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    marginRight: "-".concat(akEditorGutterPadding, "px"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    marginLeft: "-".concat(akEditorGutterPadding, "px"),
    marginBottom: 0,
    paddingTop: "var(--ds-space-050, 4px)",
    paddingBottom: "var(--ds-space-050, 4px)",
    color: 'inherit',
    /* Hover state */
    '&:hover': _defineProperty({
      // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
      boxShadow: "0px 0px 0px 1px ".concat("var(--ds-border, #0B120E24)")
    }, ".".concat(SyncBlockLabelSharedCssClassName.labelClassName), {
      opacity: 1,
      visibility: 'visible'
    })
  }, "&.".concat(BodiedSyncBlockSharedCssClassName.selectionInside), _defineProperty({
    boxShadow: "0 0 0 1px ".concat("var(--ds-border-focused, #4688EC)")
  }, ".".concat(SyncBlockLabelSharedCssClassName.labelClassName), {
    opacity: 1,
    visibility: 'visible'
  })), '&.ak-editor-selected-node', _defineProperty({
    boxShadow: "0 0 0 1px ".concat("var(--ds-border-focused, #4688EC)"),
    backgroundColor: "var(--ds-background-selected, #E9F2FE)"
  }, ".".concat(SyncBlockLabelSharedCssClassName.labelClassName), {
    opacity: 1,
    visibility: 'visible',
    backgroundColor: "var(--ds-background-selected, #E9F2FE)",
    '&::before': {
      content: '""',
      position: 'absolute',
      top: '-1px',
      left: '-1px',
      right: '-1px',
      bottom: '-1px',
      border: "1px solid ".concat("var(--ds-border-focused, #4688EC)"),
      borderRadius: "var(--ds-radius-small, 3px)",
      mask: 'linear-gradient(to bottom, black 55%, transparent 55%)',
      WebkitMask: 'linear-gradient(to bottom, black 55%, transparent 55%)',
      pointerEvents: 'none',
      zIndex: -1
    }
  })), '&.danger', _defineProperty({
    boxShadow: "0 0 0 1px ".concat("var(--ds-border-danger, #E2483D)"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    backgroundColor: "var(--ds-background-danger, #FFECEB)".concat(" !important"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-panel__icon': {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
      color: "var(--ds-icon-danger, #C9372C)".concat(" !important")
    }
  }, ".".concat(SyncBlockLabelSharedCssClassName.labelClassName), {
    backgroundColor: "var(--ds-background-danger, #FFECEB)",
    '&::before': {
      content: '""',
      position: 'absolute',
      top: '-1px',
      left: '-1px',
      right: '-1px',
      bottom: '-1px',
      border: "1px solid ".concat("var(--ds-border-danger, #E2483D)"),
      borderRadius: "var(--ds-radius-small, 3px)",
      mask: 'linear-gradient(to bottom, black 55%, transparent 55%)',
      WebkitMask: 'linear-gradient(to bottom, black 55%, transparent 55%)',
      pointerEvents: 'none',
      zIndex: -1
    }
  })), "&.".concat(SyncBlockStateCssClassName.disabledClassName), _defineProperty({
    backgroundColor: "var(--ds-background-disabled, #17171708)",
    boxShadow: "0 0 0 1px ".concat("var(--ds-border-disabled, #0515240F)"),
    userSelect: 'none'
  }, ".".concat(SyncBlockLabelSharedCssClassName.labelClassName), {
    backgroundColor: "var(--ds-surface, #FFFFFF)",
    '&::before': {
      border: 'none'
    }
  })), "&has(.".concat(SyncBlockSharedCssClassName.error, ")"), _defineProperty({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:hover:not(.ak-editor-selected-node)': {
      boxShadow: 'none'
    }
  }, ".".concat(SyncBlockLabelSharedCssClassName.labelClassName), {
    opacity: 0,
    visibility: 'hidden'
  })), "&.".concat(SyncBlockStateCssClassName.viewModeClassName), _defineProperty({
    boxShadow: 'none',
    backgroundColor: 'unset'
  }, ".".concat(SyncBlockLabelSharedCssClassName.labelClassName), {
    opacity: 0,
    visibility: 'hidden'
  })), ".".concat(BodiedSyncBlockSharedCssClassName.content), {
    padding: '0 32px',
    cursor: 'text'
  }), ".".concat(SyncBlockSharedCssClassName.renderer), {
    padding: '0 32px'
  }))
}, ".".concat(SyncBlockLabelSharedCssClassName.labelClassName), {
  color: "var(--ds-text-subtle, #505258)",
  borderRadius: "var(--ds-radius-small, 3px)",
  position: 'absolute',
  gap: "var(--ds-space-050, 4px)",
  justifyContent: 'center',
  alignItems: 'center',
  display: 'flex',
  opacity: 0,
  visibility: 'hidden',
  paddingLeft: "var(--ds-space-100, 8px)",
  paddingRight: "var(--ds-space-100, 8px)",
  paddingBottom: "var(--ds-space-050, 4px)",
  paddingTop: "var(--ds-space-050, 4px)",
  top: "var(--ds-space-negative-200, -16px)",
  right: "var(--ds-space-150, 12px)",
  backgroundColor: "var(--ds-surface, #FFFFFF)",
  maxWidth: '140px'
}));